import { render, staticRenderFns } from "./DetailPemutakhiranPencabutanKkprl.vue?vue&type=template&id=6866f6d0&"
import script from "./DetailPemutakhiranPencabutanKkprl.vue?vue&type=script&lang=js&"
export * from "./DetailPemutakhiranPencabutanKkprl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports